/* ── Player health + counters widget ─────────────────────────────────── */
.healthContainer {
  --accent: #1c8763;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: fit-content;
  min-height: 72px;
  padding: 6px 10px;
  background-color: #1a1a1a;
  border: 1px solid var(--accent);
  border-radius: 4px;
  transition: all 0.3s ease;
}

.opponent {
  --accent: #933030;
  background-color: rgba(13, 13, 13, 0.9);
  backdrop-filter: blur(10px);
}
